import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Registra il Service Worker per il caching dei tiles della mappa
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/tile-cache-sw.js")
      .then((registration) => {
        console.log("[TileCache] SW registrato:", registration.scope);
      })
      .catch((error) => {
        console.warn("[TileCache] Registrazione SW fallita:", error);
      });
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
